// Utils
// @ts-ignore
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

// Selectors
// @ts-ignore
import { selectCurrentOrganizationId } from '../currentOrganizationId/selectors';
// @ts-ignore
import { selectCurrentSeasonId } from '../currentSeasonId/selectors';
// @ts-ignore
import { selectCurrentEntityId } from '../currentEntityId/selectors';
// HACK: disobeys folder structure rules
import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from '../../components/DatePagination/selectors';

// Workspaces
import { makeSelectQueryStringValue } from '../../workspaces/react-router-selectors';
import { TimesheetEntry } from './types';

type State = {
    timesheetEntries: Record<string, TimesheetEntry>;
};

type Props = {
    timesheetEntryUuid?: string;
};

const selectTimesheetEntries = (state: State): Record<string, TimesheetEntry> =>
    state.timesheetEntries;
const selectTimesheetEntryUuid = (state: State, props: Props): any =>
    props.timesheetEntryUuid;

const selectTimesheetEntry = createDeepEqualSelector(
    [selectTimesheetEntries, selectTimesheetEntryUuid],
    (
        timesheetEntriesState: Record<string, TimesheetEntry>,
        timesheetEntryUuidProp: any
    ) => timesheetEntryUuidProp && timesheetEntriesState[timesheetEntryUuidProp]
);

const makeSelectTimesheetEntryValue = (field: string): any =>
    createDeepEqualSelector(
        selectTimesheetEntry,
        (timesheetEntryState: any) =>
            timesheetEntryState && timesheetEntryState[field]
    );

const selectLoadTimesheetEntriesParams = createDeepEqualSelector(
    [
        selectCurrentOrganizationId,
        selectCurrentSeasonId,
        selectCurrentEntityId,
        selectFirstDate,
        selectLastDate,
        makeSelectQueryStringValue('page'),
        makeSelectQueryStringValue('count'),
        makeSelectQueryStringValue('sort'),
        makeSelectQueryStringValue('entities'),
        makeSelectQueryStringValue('workTypes'),
        makeSelectQueryStringValue('groups'),
        makeSelectQueryStringValue('people')
    ],
    (
        currentOrganizationIdState: any,
        currentSeasonIdState: any,
        currentEntityIdState: any,
        firstDateState: any,
        lastDateState: any,
        queryStringPageState: any = 1,
        queryStringCountState: any = 25,
        queryStringSortState: any = 'date_ascending',
        queryStringEntitiesState: any,
        queryStringWorkTypesState: any,
        queryStringGroupsState: any,
        queryStringPeopleState: any
    ) => ({
        count: true,
        organizationId: currentOrganizationIdState,
        filter: {
            limit: queryStringCountState,
            offset: (queryStringPageState - 1) * queryStringCountState,
            order: queryStringSortState
                .split('_')
                .map((value: any) => {
                    if (value === 'descending') return 'desc';
                    return value;
                })
                .join(' ')
                .concat(', date asc, startTime asc,  uuid asc'),
            require: {
                $and: [
                    {
                        deletedAt: { $exists: false },
                        versionedAt: { $exists: false },
                        ...(queryStringWorkTypesState
                            ? { workTypeId: { $in: queryStringWorkTypesState } }
                            : {}),
                        ...(queryStringGroupsState
                            ? {
                                  'person.groups.id': {
                                      $in: queryStringGroupsState
                                  }
                              }
                            : {}),
                        ...(queryStringPeopleState
                            ? { personId: { $in: queryStringPeopleState } }
                            : {}),
                        ...(currentSeasonIdState
                            ? { 'entity.seasonId': currentSeasonIdState }
                            : {}),
                        $and: [
                            ...(currentEntityIdState
                                ? [
                                      {
                                          $or: [
                                              {
                                                  'entity.path': {
                                                      $or: [
                                                          {
                                                              $like: `/${currentEntityIdState}/%`
                                                          },
                                                          {
                                                              $equals: `/${currentEntityIdState}`
                                                          }
                                                      ]
                                                  }
                                              },
                                              {
                                                  entityId: currentEntityIdState
                                              }
                                          ]
                                      }
                                  ]
                                : []),
                            ...(queryStringEntitiesState &&
                            queryStringEntitiesState.length
                                ? [
                                      {
                                          $or: queryStringEntitiesState.map(
                                              (value: any) => ({
                                                  $or: [
                                                      {
                                                          'entity.path': {
                                                              $or: [
                                                                  {
                                                                      $like: `%/${value}/%`
                                                                  },
                                                                  {
                                                                      $like: `%/${value}`
                                                                  }
                                                              ]
                                                          }
                                                      },
                                                      {
                                                          entityId: value
                                                      }
                                                  ]
                                              })
                                          )
                                      }
                                  ]
                                : [])
                        ],
                        date: {
                            $and: [
                                {
                                    $gte: firstDateState
                                },
                                {
                                    $lte: lastDateState
                                }
                            ]
                        }
                    }
                ]
            }
        }
    })
);

export {
    selectTimesheetEntries,
    selectTimesheetEntry,
    makeSelectTimesheetEntryValue,
    selectLoadTimesheetEntriesParams
};
